import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  try {
    const token = localStorage.getItem("vlink_token");
    if (token) cfg.headers["Authorization"] = `Bearer ${token}`;
  } catch (e) {}
  return cfg;
});

export default api;
